import PropTypes from 'prop-types';

import Layout from 'components/Layout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';

import { withAuth } from 'lib/hofs';

import Heading from './Heading';
import MyOffersList from './MyOffersList';
import Sidebar from './Sidebar';

const GA_EVENT_CATEGORY = 'my_deals';

const MyOffersPage = ({ isLoading = true }) => (
  <>
    <HeadWithNoIndexAndNoFollow />
    <Layout
      gridProps={{ className: 'mb-20' }}
      headingComponent={<Heading />}
      sidebarComponent={
        <Sidebar
          className="hidden xl:flex"
          gaEventCategory={GA_EVENT_CATEGORY}
        />
      }
    >
      <MyOffersList
        gaEventCategory={GA_EVENT_CATEGORY}
        isAuthLoading={isLoading}
      />
    </Layout>
  </>
);

MyOffersPage.propTypes = {
  isLoading: PropTypes.bool,
};

export default withAuth(MyOffersPage);
